<template>
  <ExTable :dataSource="dataSource">
    <DxEditing
        :allow-adding="false"
        :allow-deleting="false"
        :allow-updating="false"
        mode="form"
    />
    <DxColumn caption="ID" data-field="Id" data-type="number"/>
    <DxColumn caption="SĐT" data-field="Phone" data-type="string"/>
    <DxColumn caption="Họ tên" data-field="Full_name" data-type="string"/>
    <DxColumn caption="Điểm" data-field="Current_point" data-type="number"/>
    <DxColumn caption="Rank" data-field="Rank_id" data-type="number"/>
    <DxColumn
        caption="Spent Cumulative Point"
        data-field="Spent_cumulative_point"
        data-type="number"
    />
    <DxColumn
        caption="Spent Cycle Point"
        data-field="Spent_cycle_point"
        data-type="number"
    />
    <DxColumn
        caption="Total Cumulative Point"
        data-field="Total_cumulative_point"
        data-type="number"
    />
    <DxColumn
        caption="Total Cycle Point"
        data-field="Total_cycle_point"
        data-type="number"
    />
    <DxColumn
        caption="Vip Voucher Use Count"
        data-field="Vip_voucher_use_count"
        data-type="number"
    />
    <DxColumn
        caption="CMT/CCCD"
        data-field="Identity_card_number"
        data-type="number"
    />
    <DxColumn
        caption="Ngày sinh"
        data-field="Date_birth_day"
        data-type="string"
    />
    <DxColumn caption="Địa chỉ" data-field="Address" data-type="string"/>
  </ExTable>
</template>
<script>
import ExTable from "@/views/components/ExTable.vue";
import {DxColumn, DxEditing} from "devextreme-vue/data-grid";
import {$ctx} from "@themeConfig";

export default {
  components: {
    DxColumn,
    DxEditing,
    ExTable
  },
  data() {
    return {
      dataSource: {
        store: {
          type: "odata",
          version: 4,
          url: $ctx.API_URL + "odata.svc/" + this.$route.params.type,
          beforeSend: e => {
            e.headers = {
              apiKey: localStorage.getItem("accessToken")
            };
          }
        }
      }
    };
  },
  watch: {
    $route(n, o) {
      this.dataSource = {
        store: {
          type: "odata",
          version: 4,
          url: $ctx.API_URL + "odata.svc/" + n.params.type,
          beforeSend: e => {
            e.headers = {
              apiKey: localStorage.getItem("accessToken")
            };
          }
        }
      };
    }
  }
};
</script>
<style>
#gridContainer {
  height: 80vh;
}
</style>
